import { defineNuxtPlugin } from '#app/nuxt'
import { LazySvgo3dcube, LazySvgo3dcubewhite, LazySvgoANDROID, LazySvgoBNB, LazySvgoGFALID, LazySvgoGFALTokenWhiteOverBlack, LazySvgoGFALToken, LazySvgoGFALTokenBlackOverWhite, LazySvgoGFALTokenGray, LazySvgoGFALWarning, LazySvgoIOS, LazySvgoMAC, LazySvgoPLAYSTATION, LazySvgoWINDOWS, LazySvgoXBOX, LazySvgoApple, LazySvgoArrowBlockPurple, LazySvgoBell, LazySvgoBlueCheck, LazySvgoCart, LazySvgoCheckmarkGreen, LazySvgoCheckmarkRed, LazySvgoFacebook, LazySvgoFullscreen, LazySvgoGoogle, LazySvgoHexagonCheck, LazySvgoKey, LazySvgoLock, LazySvgoSell, LazySvgoTag, LazySvgoUser, LazySvgoVisibility, LazyNuxtIcon } from '#components'
const lazyGlobalComponents = [
  ["Svgo3dcube", LazySvgo3dcube],
["Svgo3dcubewhite", LazySvgo3dcubewhite],
["SvgoANDROID", LazySvgoANDROID],
["SvgoBNB", LazySvgoBNB],
["SvgoGFALID", LazySvgoGFALID],
["SvgoGFALTokenWhiteOverBlack", LazySvgoGFALTokenWhiteOverBlack],
["SvgoGFALToken", LazySvgoGFALToken],
["SvgoGFALTokenBlackOverWhite", LazySvgoGFALTokenBlackOverWhite],
["SvgoGFALTokenGray", LazySvgoGFALTokenGray],
["SvgoGFALWarning", LazySvgoGFALWarning],
["SvgoIOS", LazySvgoIOS],
["SvgoMAC", LazySvgoMAC],
["SvgoPLAYSTATION", LazySvgoPLAYSTATION],
["SvgoWINDOWS", LazySvgoWINDOWS],
["SvgoXBOX", LazySvgoXBOX],
["SvgoApple", LazySvgoApple],
["SvgoArrowBlockPurple", LazySvgoArrowBlockPurple],
["SvgoBell", LazySvgoBell],
["SvgoBlueCheck", LazySvgoBlueCheck],
["SvgoCart", LazySvgoCart],
["SvgoCheckmarkGreen", LazySvgoCheckmarkGreen],
["SvgoCheckmarkRed", LazySvgoCheckmarkRed],
["SvgoFacebook", LazySvgoFacebook],
["SvgoFullscreen", LazySvgoFullscreen],
["SvgoGoogle", LazySvgoGoogle],
["SvgoHexagonCheck", LazySvgoHexagonCheck],
["SvgoKey", LazySvgoKey],
["SvgoLock", LazySvgoLock],
["SvgoSell", LazySvgoSell],
["SvgoTag", LazySvgoTag],
["SvgoUser", LazySvgoUser],
["SvgoVisibility", LazySvgoVisibility],
["NuxtIcon", LazyNuxtIcon],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
